import { theme, darkMode } from 'cdk-radial';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Add black to the color rotation
const appBlack = {
  50: { value: '#f2f2f2 ' },
  100: { value: '#e6e6e6' },
  200: { value: '#cccccc' },
  300: { value: '#b3b3b3' },
  400: { value: '#999999' },
  500: { value: '#808080' },
  600: { value: '#666666' },
  700: { value: '#4d4d4d' },
  800: { value: '#333333' },
  900: { value: '#1a1a1a' },
};

// Colors to rotate through
export const appColors = [
  theme.color.secondary.cherryBombRed,
  theme.color.secondary.fireballOrange,
  theme.color.secondary.bubbleGumPink,
  theme.color.secondary.grapeApePurple,
  theme.color.secondary.cookieMonsterBlue,
  theme.color.secondary.seaMistTeal,
  theme.color.secondary.kermitGreen,
  appBlack,
];

export const themes = [theme, darkMode];

// Shades to use for the header and hover state for the tags.
const appShade = 800;
const appHover = 200;
const tagShade = 100;
const tagShadeHover = 300;
const tagShadeSelected = 700;

export const useStore = create(
  persist(
    (set) => ({
      activeTags: [],
      appColor: 5,
      examplesSort: { type: 'modified', direction: 'descending' },
      headerConfig: {
        foreground: theme.color.additional.alwaysWhite.value,
        background: appColors[5][appShade].value,
        tagBackground: appColors[5][tagShade].value,
        tagHover: appColors[5][tagShadeHover].value,
        tagSelected: appColors[5][tagShadeSelected].value,
        hover: appColors[5][appHover].value,
        title: 'RADIAL PARK',
        subtitle: 'cdk-radial examples',
      },
      isReadmeVisible: true,
      themeNumber: 0,
      themeConfig: {
        theme: themes[0],
      },
      addActiveTag: (tag) => set((state) => ({ activeTags: [...new Set([...state.activeTags, tag])] })),
      clearActiveTags: () =>
        set(() => ({
          activeTags: [],
        })),
      nextColor: () =>
        set((state) => {
          const newAppColor = (state.appColor + 1) % appColors.length;
          const newHeaderConfig = {
            ...state.headerConfig,
            background: appColors[newAppColor][appShade].value,
            hover: appColors[newAppColor][appHover].value,
            tagBackground: appColors[newAppColor][tagShade].value,
            tagHover: appColors[newAppColor][tagShadeHover].value,
            tagSelected: appColors[newAppColor][tagShadeSelected].value,
          };
          return { appColor: newAppColor, headerConfig: newHeaderConfig };
        }),

      switchTheme: () => {
        set((state) => {
          const newThemeNumber = state.themeNumber === 0 ? 1 : 0;
          const newThemeConfig = {
            theme: themes[newThemeNumber],
          };
          return { themeNumber: newThemeNumber, themeConfig: newThemeConfig };
        });
      },
      toggleActiveTag: (tag) =>
        set((state) => {
          if (state.activeTags.includes(tag)) {
            // remove tag
            return { activeTags: state.activeTags.filter((item) => item !== tag) };
          } else {
            // add tag
            return { activeTags: [...new Set([...state.activeTags, tag])] };
          }
        }),
      toggleReadme: () => set((state) => ({ isReadmeVisible: !state.isReadmeVisible })),
      toggleSort: (type) =>
        set((state) => {
          const direction = state.examplesSort.direction === 'ascending' ? 'descending' : 'ascending';
          return { examplesSort: { direction, type } };
        }),
    }),
    { name: 'radial-park' }
  )
);
